import { Users } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import { Validator } from '@leverege/validator';
import I18N from '@leverege/i18n';
import EmailSMSConfirmation from "./EmailSMSConfirmation.js";
import SmsListItem from "./SmsListItem.js";
import SMSPreActivate from "./SMSPreActivate.js";
const {
  t
} = I18N.ns('login.twoFactor.sms');
export default {
  type: 'sms',
  get name() {
    return t('name');
  },
  get description() {
    return t('description');
  },
  listItem: SmsListItem,
  confirmationComponent: EmailSMSConfirmation,
  preActivateComponent: SMSPreActivate,
  validatePreActivateData: data => {
    return Validator.isPhone(data?.phone);
  },
  onPreActivate: async (profile, data, password) => {
    const res = await GlobalState.dispatch(Users.preActivateTwoFactorMethod(profile.id, 'sms', {
      ...data,
      password
    }));
    return res;
  }
};